<template>
  <b-modal id="modal-external-id" ref="productSearchModal" :title="$t('sandoz.product_search')"
                    :ok-only="true" size="xl" :ok-title="$t('core.cancel')">
    <o-table ref="tableList" url="/api/kuko_products?include=group" :shadow="false" :enable-new="false">
        <template slot="filter">
          <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="false">
            <o-filter-text :title="$t('sandoz.product')" column="product"></o-filter-text>
            <o-filter-text :title="$t('sandoz.pharma_code')" column="pharma_code"></o-filter-text>
            <o-filter-text :title="$t('sandoz.gln')" column="gln"></o-filter-text>
            <o-filter-select :items="productGroups" value-field="id" text-field="product_group" :title="$t('sandoz.product_group')" column="product_group_id"></o-filter-select>
          </o-filter>
        </template>
        <template slot="head">
            <o-table-header :sortable="false"><b-form-checkbox @change="selectAllProducts()"></b-form-checkbox></o-table-header>
            <o-table-header column="pharma_code">{{$t('sandoz.pharma_code')}}</o-table-header>
            <o-table-header column="gln">{{$t('sandoz.gln')}}</o-table-header>
            <o-table-header column="product">{{$t('sandoz.product')}}</o-table-header>
            <o-table-header column="efp">{{$t('sandoz.efp')}}</o-table-header>
            <o-table-header column="product_group_id">{{$t('sandoz.product_group')}}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
            <td><b-form-checkbox v-model="productArray" :disabled="productArray.includes(props.item.id)" :value="props.item.id" @click.native.stop @change="selectProduct(props.item, true)"></b-form-checkbox></td>
            <td>{{ props.item.pharma_code }}</td>
            <td>{{ props.item.gln }}</td>
            <td>{{ props.item.product }}</td>
            <td>{{ props.item.efp }}</td>
            <td v-html="(props.item.group && props.item.group.data) ? props.item.group.data.description_scheme : '-'"></td>
        </template>
        <template slot="body-controls" slot-scope="props">
          <td class="text-right">
                <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                    <b-btn variant="primary" @click="selectProduct(props.item)">
                      <fa icon="arrow-right"/>
                    </b-btn>
                </div>
            </td>
        </template>
    </o-table>
  </b-modal>
</template>

<script>
  import axios from 'axios'

  export default {
    props: {
      productGroupsFilter: {
        type: Array
      }
    },
    data: () => ({
      query: '',
      owningComponent: null,
      productGroups: [],
      productArray: []
    }),
    mounted() {
      this.loadProductGroups()
    },
    methods: {
      loadProductGroups() {
        axios.get('/api/kuko_product_groups?per_page=9999').then(response => {
          this.productGroups = response.data.data
        })
      },
      showProductSearchModal(owningComponent) {
        this.owningComponent = owningComponent
        this.$refs.productSearchModal.show()
      },
      selectProduct(product, viaCheckbox = false) {
        this.$emit('product-selected', {owningComponent: this.owningComponent, product: product})
        if(!viaCheckbox) {
          this.$refs.productSearchModal.hide()
        }
      },
      selectAllProducts() {
        let tableData = this.$refs.tableList.data
        tableData.data.forEach((value) => {
          if(!this.productArray.includes(value.id)) {
            this.productArray.push(value.id)
            this.selectProduct(value, true)
          }
        });
        this.$refs.productSearchModal.hide()
      }
    }
  }
</script>
